






































































import { auth } from 'firebase/app';
import Vue from 'vue';
import FacebookLogin from '@/vue-components/auth/FacebookLogin.vue';
import { UserWebDAO } from '@/web/dao/user/UserWebDAO';

export default Vue.extend({
  name: 'Login',
  components: {
    FacebookLogin,
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      errorMessage: '',
    };
  },
  computed: {
    title(): string {
      return 'Sparkello - Login';
    },
  },
  methods: {
    login() {
      auth().signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(() => {
        console.log('Login success');
        this.$store.commit('setCurrentUser', auth().currentUser);
        UserWebDAO.instance.getCurrentUser().then((userProfile) => {
          this.$store.commit('setUserProfile', userProfile);
        });
        this.$router.push(sessionStorage.getItem('redirectPath') || '/dreams');
        sessionStorage.removeItem('redirectPath');
      }).catch(error => {
        console.log(error);
        this.errorMessage = error.message;
      });
    },
    showFacebookLogin(): boolean {
      return process.env.VUE_APP_FACEBOOK_ENABLED == 'true';
    }
  },
});
